<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">Portalbrugere</h1>
    <div class="comp-header__actions">
      <button [admRequiresFeatureRole]="roles['actions-log.read']" mat-button type="button" (click)="openActionLog()">
        <mat-icon>list</mat-icon>
        <span>Hændelseslog</span>
      </button>
      <button [admRequiresFeatureRole]="roles['user.write']" (click)="openCreateUserModal()" mat-flat-button color="primary" type="button">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#user-add-s"></use></svg>
        <span>Opret bruger</span>
      </button>
    </div>
  </div>
  <div class="comp-header__queries" [formGroup]="state.form">
    <adm-text-search
      placeholder="navn, e-mail, org. mm."
      (search$)="querySearchInput($event)"
      [searchText]="state.form.controls.query.value ?? ''" />

    <mat-form-field>
      <mat-label>Vælg rolle</mat-label>
      <mat-select #roleSelect formControlName="roleName" okCustomDropDownArrowDirective>
        <mat-option [value]="null">Alle</mat-option>
        @for (role of state.userRoles; track role.name) {
          <mat-option [value]="role.name">
            {{ role.description }}
          </mat-option>
        }
      </mat-select>
      @if (state.form.controls.roleName.value) {
        <button
          matSuffix
          class="clear-input-field-button"
          type="button"
          (click)="state.updateRole(null); $event.stopPropagation()"
          aria-label="Ryd indhold i feltet">
          <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
        </button>
      }
      <mat-icon matSuffix></mat-icon>
    </mat-form-field>

    <adm-org-typeahead
      [initialId]="state.form.controls.organizationId.value ?? undefined"
      [resetTrigger]="state.resetOrgTrigger()"
      (itemSelected)="organizationSelected($event)"
      (organizationsFetched)="organizationsFetched($event)" />

    <div class="comp-header__filter-checkbox">
      <mat-checkbox formControlName="includeDisabled">Vis deaktiverede</mat-checkbox>
    </div>
    <button class="comp-header__reset-button" (click)="resetFilter()" mat-stroked-button>Nulstil</button>
  </div>
</div>
<div class="comp-main users">
  <adm-users-list (refreshAfterUpdateEvent)="refreshAfterUpdate($event)" (refreshAfterDeleteEvent)="refreshAfterDelete($event)" />
</div>
